module.exports = __webpack_public_path__ + "img/REGISTRO 2.cd74cd36.png";